export default __webpack_public_path__ + "static/modularfrp2-d136309a794b31f4eb385564158b4461.jpg";